/*
  Complete logout hook up with the backend.

  sign out button triggers logout.

  working with integration with backend over the same domain.

*/

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logOutUser } from 'redux/auth/authService';
import { access } from 'constants/index';

import {
   UncontrolledDropdown,
   DropdownToggle,
   DropdownMenu,
   DropdownItem,
} from 'reactstrap';

import {
   Settings,
} from 'react-feather';

import { UserIcon } from 'app/employer/vectors';
import AccessControl from '../../../components/AccessControl';

class UserDropDownMenuComponent extends Component {
   constructor(props) {
      super(props);

      this.logUserOutAction = this.logUserOutAction.bind(this);
   }

   logUserOutAction() {
      this.props.logOutUser();
   }

   render() {
      const { user } = this.props;
      return (
         <UncontrolledDropdown nav inNavbar>
            <span className='d-inline-block d-sm-none'>
               <DropdownToggle nav caret>
                  <Settings size={20} className='align-middle'/>
               </DropdownToggle>
            </span>
            <span className='d-none d-sm-inline-block'>
               <DropdownToggle nav caret >
                  <UserIcon height={24} fill='#666666' className='float-left mr-2'/>
                  <div className='float-left'>{`${ user.fname } ${ user.lname }`}</div>
               </DropdownToggle>
            </span>
            <DropdownMenu right>
               {/* <DropdownItem>
            <User size={18} className="align-middle mr-2" />
             <Link to="/account">Account</Link>
          </DropdownItem> */}
               <AccessControl access={access.byRole.employer.all}>
                  <>
                     {
                        // Account Details (/employer/account) was a DE (AOE-backed)
                        // page — retired with the AOE shutdown 2026-08-13
                     }
                     <DropdownItem divider/>
                  </>
               </AccessControl>
               <DropdownItem tag={Link} to='/help'>Help</DropdownItem>
               <DropdownItem onClick={this.logUserOutAction}>Sign out</DropdownItem>
            </DropdownMenu>
         </UncontrolledDropdown>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.loggedInUser,
   };
};

const mapDispatchToProps = (dispatch) => ({
   logOutUser: (callBack) => dispatch(logOutUser(callBack)),
});

export default connect(
   mapStateToProps,
   mapDispatchToProps,
)(UserDropDownMenuComponent);
